//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Tooltip from '@/mixins/tooltip';
import { FaIconNames } from './icons';

export default {
  name: 'DpIcon',
  mixins: [Tooltip],
  props: {
    name: { type: String, required: true, default: 'default' },
    animation: { type: String, default: null },
    rotate: { type: [Number, String], default: null },
    rawName: { type: String, default: null },
    duotone: { type: Boolean, default: false },
    solid: { type: Boolean, default: false },
    faded: { type: Boolean, default: false },
    brand: { type: Boolean, default: false },
    size: { type: [Number, String], default: null },
  },
  computed: {
    iconStyle() {
      if (this.rawName) return null;
      if (this.duotone) return 'fad';
      if (this.solid) return 'fa';
      if (this.brand) return 'fab';
      return 'far';
    },
    iconName() {
      if (this.rawName) {
        return this.rawName;
      }

      if (FaIconNames[this.name]) {
        return `fa-${FaIconNames[this.name]}`;
      }

      return `fa-${FaIconNames.default}`;
    },
    iconAnimation() {
      const { animation } = this;
      if (animation === 'spinning') {
        return 'fa-spin';
      }
      if (animation === 'spinning-alt') {
        return 'fa-spin dp-icon--animation-reversed';
      }
      return null;
    },
    iconSize() {
      const { size } = this;
      if (!size) return null;
      return `dp-icon--size-${size}`;
    },
    styles() {
      if (!this.rotate) {
        return null;
      }
      return {
        transform: `rotate(${this.rotate}deg)`,
      };
    },
  },
};
